import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { getCityGenericNameFromNumber } from "Utils/Common";
import { StringMap } from "./StringMap";
import { StringValue } from "./StringValue";
import { StringArray } from "./StringArray";
import { getTroopNameFromId } from "Utils/Common";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Auto Mine">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringMap
          label={"Selected Cities"}
          valueMap={task.taskstatusdetail.selectedcities}
          valueParser={(k, v) => getCityGenericNameFromNumber(k)}
        />
        <StringMap
          label={"Troops to send"}
          valueMap={task.taskstatusdetail.troops}
          valueParser={(k, v) => (
            <>
              {getTroopNameFromId(k)}: {v}
            </>
          )}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Mine Config Selected"}
          value={
            <>
              {task.taskstatusdetail.getfarthestmine && <span>[Farthest]</span>}
              [{task.taskstatusdetail.doExCavs && <span>'ExCavs'</span>}
              {task.taskstatusdetail.doComCavs && <span>'ComCavs'</span>}]
            </>
          }
        />
        <StringValue
          label={"Port Cities before mining?"}
          value={task.taskstatusdetail.portcitiestocorners}
        />
        <StringValue
          label={"Max Rounds"}
          value={task.taskstatusdetail.maxRounds}
        />
        <StringValue
          label={"Force Recall miners on stop"}
          value={task.taskstatusdetail.forcerecallminesonstopping}
        />
        <StringValue
          label={"Attack only mines having more than shards:"}
          value={task.taskstatusdetail.minShards}
        />
        <StringValue
          label={"Marches Done"}
          value={
            task.taskstatusdetail.totalhitsdone +
            "/" +
            task.taskstatusdetail.noOfHits
          }
        />
        <StringValue
          label={"Marches Out"}
          value={
            task.taskstatusdetail.miningetas
              ? task.taskstatusdetail.miningetas.length
              : ""
          }
        />
        <StringArray
          label={"ETAs"}
          array={task.taskstatusdetail.miningetas}
          valueParser={(item) => item.minername + " : " + item.minereta}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
